<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>车型：</label>
                <el-input v-model="search_Obj.f_car_type" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="email" label="邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="vehicle_id" label="车辆ID" sortable="custom"></el-table-column>
                <el-table-column prop="vin" label="VIN" sortable="custom"></el-table-column>
                <el-table-column prop="car_type" label="车型" sortable="custom"></el-table-column>
                <el-table-column prop="full_endurance" label="满电续航(km)" sortable="custom"></el-table-column>
                <el-table-column prop="full_battery_capacity" label="电池容量(度)" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="提交时间" sortable="custom"></el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看电池反馈"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'batteryFeedbackList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '电池反馈',
            menu_id: 4300,
            list_url: "/api/admin/batteryfeedback/list",
            search_Obj: {
                f_email: '',
                f_car_type: '',
            },
            del_Obj:{
                url:'/api/admin/batteryfeedback/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>